import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {takeUntil} from 'rxjs/operators';
import {MatSnackBar} from '@angular/material/snack-bar';
import {SubscriptionEnrollDto} from '../../dtos/subscriptionEnroll.dto';
import {AdminNavigationService} from '../../services/admin-navigation.service';
import {SubscriptionAdminService} from '../../services/api/subscription-admin.service';
import {BaseComponent} from '../base.component';
import {SubscriptionPlan, SubscriptionPlanDaoService, SubscriptionPlanType} from 'common';
import {RecentAccountActivitySubscriptionDto} from '../../dtos/recentAccountActivitySubscription.dto';

@Component({
    selector: 'app-subscription-form',
    templateUrl: './add-subscription.component.html',
    styleUrls: ['./add-subscription.component.scss'],
})

export class AddSubscriptionComponent extends BaseComponent implements OnInit {
    private userCode: string;
    public plans: SubscriptionPlan[];
    public legacyPlans: SubscriptionPlan[];
    public selectedPlan: SubscriptionPlan;
    private selectedDuration: number;
    private _showCalendarComponent :boolean = false;

    notesText: string;
    notesCharacterCount = 0;

    constructor(private _route: ActivatedRoute,
                private _subscriptionAdminService: SubscriptionAdminService,
                private _snackbar: MatSnackBar,
                private subscriptionPlanDaoService: SubscriptionPlanDaoService,
                private adminNavigation: AdminNavigationService) {
        super();
        this.notesText = '';
        this.plans = [subscriptionPlanDaoService.getForType(SubscriptionPlanType.STARTER), subscriptionPlanDaoService.getForType(SubscriptionPlanType.PREMIUM), subscriptionPlanDaoService.getForType(SubscriptionPlanType.EXCELLENCE)];
        this.legacyPlans = [subscriptionPlanDaoService.getForType(SubscriptionPlanType.PRO), subscriptionPlanDaoService.getForType(SubscriptionPlanType.PRO_PLUS)];
    }

    ngOnInit(): void {
        this._route.paramMap
            .pipe(takeUntil(this.destroySubject))
            .subscribe((params) => {
                this.userCode = params.get('code');
            });
    }

    onPlanSelected(plan: SubscriptionPlan): void  {
        this.selectedPlan = plan;
    }

    onIndefiniteSelected(): void  {
        this.selectedDuration = -1;
        this._showCalendarComponent = false;
    }

    onDurationSelected(): void  {
        this.selectedDuration = undefined;
        this._showCalendarComponent = true;
    }

    onDateChanged(event: MatDatepickerInputEvent<Date>): void  {
        if (!event.value) {
            return;
        }
        const endingDate = new Date(event.value.toString()).getTime();
        const nowDate = new Date().getTime();
        const diffTime = Math.abs(endingDate - nowDate);
        this.selectedDuration = Math.ceil(diffTime / (RecentAccountActivitySubscriptionDto.DAY_IN_MS));
    }

    onInputChange(): void  {
        this.notesCharacterCount = this.notesText.length;
    }

    onAddSubscription(): void  {
        if (this.userCode && this.selectedPlan && this.selectedDuration) {
            this._subscriptionAdminService.enrollSubscription(new SubscriptionEnrollDto(this.userCode, this.selectedPlan.code, this.selectedDuration, this.notesText))
                .subscribe(response => {
                    this.adminNavigation.goToAccount(this.userCode);
                }, error => {
                    this.notification.info(`Add Subscription Failed: ${error.statusText} (${error.status})`);
                });
        }
    }

    public validDate(): boolean {
        return !!this.selectedDuration;
    }

    public validNotes(): boolean {
        return this.notesText.length > 0;
    }

    public get selectedPlanType(): SubscriptionPlanType | null {
        if (!this.selectedPlan) {
            return null;
        }
        return this.selectedPlan.type;
    }

    public get showCalendarComponent(): boolean {
        return this._showCalendarComponent;
    }
}
